import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faBellExclamation,
  faRoute,
} from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import { NextJourneyDto } from "../../../types/journeys/NextJourney";
import { FormattedDate } from "../../common";
import { LatestIncompleteAnswerSetDto } from "../../../types/dtos/dashboards/LatestIncompleteAnswerSetDto";

interface PeopleJourneyDetailsProps {
  currentJourneyTitle?: string;
  onLiveJourneyClick: () => void;
  nextJourney: NextJourneyDto | null;
  latestIncompleteAnswerSet: LatestIncompleteAnswerSetDto | null;
}

/** Displays the current and next journey for a person */
const PeopleJourneyDetails = ({
  currentJourneyTitle,
  onLiveJourneyClick,
  nextJourney,
  latestIncompleteAnswerSet,
}: PeopleJourneyDetailsProps) => {
  const { t } = useTranslation();

  const assignedJourneyTitle =
    currentJourneyTitle || latestIncompleteAnswerSet?.title;
  const showAssignedJourneyButton = !!currentJourneyTitle;

  return (
    <div className="flex items-center gap-4 mt-2 py-2">
      <div>
        <FontAwesomeIcon icon={faRoute} className="text-primary" size="lg" />
      </div>
      <div className="flex-1">
        <div className="flex gap-4">
          <div>
            <p className="text-base text-[#5d5d5d]">
              <span className="coloured-text">{"In progress"}:</span>
              {assignedJourneyTitle && (
                <>
                  <span className="pl-1.5 text-[#5d5d5d]">
                    {assignedJourneyTitle}
                  </span>
                  {showAssignedJourneyButton && (
                    <button
                      onClick={onLiveJourneyClick}
                      className="ml-3 group bg-gray-200 hover:bg-gray-300 rounded-sm py-1 px-3 border border-gray-300 text-sm"
                    >
                      <FontAwesomeIcon
                        icon={faBell}
                        className="group-hover:hidden"
                      />
                      <FontAwesomeIcon
                        icon={faBellExclamation}
                        className="hidden group-hover:inline-block"
                      />
                      <span className="pl-1.5">
                        {t(
                          "Pages.ManagerDashboard.Popup.LiveJourney.SendReminderButton"
                        )}
                      </span>
                    </button>
                  )}
                </>
              )}
              {!assignedJourneyTitle && (
                <span className="pl-1.5">
                  {/*t("Dashboards.None")*/ "No active journey"}
                </span>
              )}
            </p>
          </div>
          {nextJourney && (
            <div className="lg:pl-4">
              <p className="text-base">
                {nextJourney.expectedStartDate && (
                  <span className="coloured-text">
                    <FormattedDate
                      date={new Date(nextJourney.expectedStartDate)}
                      displayMode="FROM-NOW"
                      className="inline-block first-letter:uppercase"
                    />
                    :
                  </span>
                )}
                {!nextJourney.expectedStartDate && (
                  <span className="coloured-text">{"Next up"}:</span>
                )}

                <span className="pl-1.5 text-[#5d5d5d]">
                  {nextJourney.title}
                </span>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PeopleJourneyDetails;
